import React, { useState } from 'react';
import {
  Menu,
  Search,
  HelpCircle,
  UserCircle,
  LogOut,
} from 'lucide-react';
import Logo from './Logo';

function AppHeader({
  user,
  version,
  onSidebarToggle,
  onSearchOpen,
  onProfileClick,
  onHelpOpen,
  onLogout,
}) {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const toggleUserMenu = (e) => {
    e.stopPropagation();
    setIsUserMenuOpen(open => !open);
  };

  return (
    <header className="App-header">
      <div className="header-left">
        <button
          className="menu-toggle"
          onClick={(e) => { e.stopPropagation(); onSidebarToggle(); }}
        >
          <Menu size={24} />
        </button>
        <Logo />
        <h1 className="header-title-hide-mobile">
          Farm Admin <span style={{ fontSize: '0.75rem', fontWeight: 'normal', opacity: 0.6, marginLeft: '0.5rem' }}>v{version}</span>
        </h1>
      </div>

      <div className="header-search-container">
        <div className="header-search-box" onClick={onSearchOpen}>
          <Search size={18} />
          <span>Search for records...</span>
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
            <span className="key-hint">⌘ K</span>
          </div>
        </div>
        <div className="search-help-hint" title="Search supports prefixes like 'harvest <name>', 'sale <tally>', etc.">
          <HelpCircle size={18} />
          <div className="search-tooltip">
            <strong>Intelligent Search</strong>
            <p>Try prefixes like:</p>
            <ul>
              <li><code>harvest name</code></li>
              <li><code>sale tally#</code></li>
              <li><code>death location</code></li>
              <li><code>employee name</code></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="header-right">
        <button className="mobile-search-btn" onClick={onSearchOpen} title="Search records">
          <Search size={24} />
        </button>
        <div className="user-menu-container">
          <button
            className="user-profile-button"
            onClick={toggleUserMenu}
            title={user.username}
          >
            <div className="user-profile-circle">
              {user.username.charAt(0).toUpperCase()}
            </div>
          </button>

          {isUserMenuOpen && (
            <>
              <div className="dropdown-overlay" onClick={() => setIsUserMenuOpen(false)} />
              <div className="user-dropdown" onClick={(e) => e.stopPropagation()}>
                <div className="user-dropdown-header">
                  <div className="user-profile-circle large">
                    {user.username.charAt(0).toUpperCase()}
                  </div>
                  <div className="user-info">
                    <span className="user-name">{user.username}</span>
                    <span className="user-role">{user.role.toUpperCase()}</span>
                  </div>
                </div>
                <div className="sidebar-divider" />
                <button
                  className="dropdown-item"
                  onClick={() => { onProfileClick(); setIsUserMenuOpen(false); }}
                >
                  <UserCircle size={20} />
                  <span>My Profile</span>
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => { onHelpOpen(); setIsUserMenuOpen(false); }}
                >
                  <HelpCircle size={20} />
                  <span>Help & Features</span>
                </button>
                <button className="dropdown-item logout" onClick={onLogout}>
                  <LogOut size={20} />
                  <span>Sign Out</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default AppHeader;
